import { render } from "./WCBottomNavigation.vue?vue&type=template&id=3ab9add8&scoped=true"
import script from "./WCBottomNavigation.vue?vue&type=script&lang=js"
export * from "./WCBottomNavigation.vue?vue&type=script&lang=js"

import "./WCBottomNavigation.vue?vue&type=style&index=0&id=3ab9add8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab9add8"]])

export default __exports__